import { FC } from 'react';
import { DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';

import DataGridPro from '../../../../../components/CDGridPro';

import { InventorySource as DspInventorySource } from '../../../../../types/Inventory';

type CampaignAdGroupInventoryDataGridProps = Omit<DataGridProProps, 'columns' | 'rows'> & {
    rows: DspInventorySource[];
};

const CampaignAdGroupInventoryDataGrid: FC<CampaignAdGroupInventoryDataGridProps> = ({ rows, ...props }) => {
    const columns: GridColDef[] = [
        {
            flex: 1,
            field: 'inventorySourceType',
            headerName: 'Inventory Source',
            filterable: false,
        },
        {
            flex: 1,
            field: 'inventoryType',
            headerName: 'Inventory Supply',
            filterable: false,
        },
    ];

    const getRowId = (row: DspInventorySource): string | number => {
        return row.id as string;
    };

    return (
        <DataGridPro
            // Overridable props
            pageSize={5}
            {...props}
            disableColumnPinning
            getRowId={getRowId}
            columns={columns}
            rows={rows}
            slots={{
                toolbar: null,
            }}
        />
    );
};
export default CampaignAdGroupInventoryDataGrid;
